"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavItem = exports.StyledNavItem = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _theming = require("@storybook/theming");

var _HeaderContext = require("./HeaderContext");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledNavItem = /*#__PURE__*/(0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e154td7m0"
} : {
  target: "e154td7m0",
  label: "StyledNavItem"
})("display:inline-flex;height:3rem;line-height:3rem;align-items:center;&& svg{margin-right:0;}", function (props) {
  return props.showDesktop && /*#__PURE__*/(0, _theming.css)("display:none;@media (min-width: ", props.navBreakpoint, "px){display:inline-flex;}" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledNavItem;"));
}, " ", function (props) {
  return props.showMobile && /*#__PURE__*/(0, _theming.css)("@media (min-width: ", props.navBreakpoint, "px){display:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:StyledNavItem;"));
}, ";");
exports.StyledNavItem = StyledNavItem;
var NavItem = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _useContext = (0, _react.useContext)(_HeaderContext.HeaderContext),
      navBreakpoint = _useContext.navBreakpoint;

  return /*#__PURE__*/_react["default"].createElement(StyledNavItem, (0, _extends2["default"])({
    ref: ref,
    navBreakpoint: navBreakpoint
  }, props));
});
exports.NavItem = NavItem;